export default "__VITE_ASSET__7721a2d3__"